/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCustomChatCreateChatRequest,
  TCustomChatCreateChatModel,
  IMappers,
  TCustomChatCreateChatResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV2CustomChatSendMessageResponse } from '../../../entities/create_custom_chat/V2CustomChatSendMessageResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createCustomChatCreateChatModel(parameters: TCustomChatCreateChatRequest): TCustomChatCreateChatModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v2/custom-chat/create-chat/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICustomChatCreateChatOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCustomChatCreateChatRequest;
}

export async function fetchCustomChatCreateChat<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICustomChatCreateChatOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCustomChatCreateChatResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCustomChatCreateChatModel(parameters),
    config,
  )) as FetchResponse<TCustomChatCreateChatResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV2CustomChatSendMessageResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCustomChatCreateChatResponse>;
}
